import { Box, Container, Grid, Typography } from '@mui/material';
import React from 'react';

const Techno = () => {
  return (
    <>
      <Box className="counter-area" sx={{ py: 6, textAlign: 'center' }}>
        <Box
          component="img"
          src="/images/recg.svg"
          alt="recg"
          sx={{ width: { xs: '70%', md: '35%' }, mb: 4 }}
          loading="lazy"
        />
        <Container maxWidth="xl">
          <Grid
            container
            spacing={4}
            justifyContent="center"
            alignItems="center"
          >
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <Box>
                <Box
                  component="img"
                  src="/images/startupindia.webp"
                  alt="step"
                  sx={{ width: '55%' }}
                  className="counter-images"
                />
                <Typography mt={3} sx={{ color: '#fff' }}>
                  Startup India Recognized Startup
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <Box
                sx={{
                  borderLeft: { md: '1px solid #ccc' },
                  borderRight: { md: '1px solid #ccc' },
                  px: 2
                }}
              >
                <Box
                  component="img"
                  src="/images/thiruzila_logo.png"
                  alt="recg"
                  sx={{ width: '40%' }}
                  className="counter-images"
                  loading="lazy"
                />
                <Typography mt={3} sx={{ color: '#fff' }}>
                  Event Technology Partner - Startup Thiruvizha Madurai Edition
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <Box>
                <Box
                  component="img"
                  src="/images/startuptn-blue.png"
                  alt="roc"
                  sx={{ width: '55%' }}
                  className="counter-images"
                  loading="lazy"
                />
                <Typography mt={3} sx={{ color: '#fff' }}>
                  StartupTN Empanelled Vendor
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>

      <div className="counter-area1">
        <Box
          component="img"
          src="/images/recg.svg"
          alt="recg"
          sx={{ width: { xs: '70%', md: '35%' }, mb: 4 }}
          loading="lazy"
        />
        <Container maxWidth="xl">
          <Grid
            container
            spacing={4}
            justifyContent="center"
            alignItems="center"
          >
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <Box>
                <Box
                  component="img"
                  src="/images/startupindia.webp"
                  alt="step"
                  sx={{ width: '55%' }}
                  className="counter-images"
                />
                <Typography mt={3} sx={{ color: '#fff' }}>
                  Startup India Recognized Startup
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <Box
                sx={{
                  borderLeft: { md: '1px solid #ccc' },
                  borderRight: { md: '1px solid #ccc' },
                  px: 2
                }}
              >
                <Box
                  component="img"
                  src="/images/thiruzila_logo.png"
                  alt="recg"
                  sx={{ width: '40%' }}
                  className="counter-images"
                  loading="lazy"
                />
                <Typography mt={3} sx={{ color: '#fff' }}>
                  Event Technology Partner - Startup Thiruvizha Madurai Edition
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <Box>
                <Box
                  component="img"
                  src="/images/startuptn-blue.png"
                  alt="roc"
                  sx={{ width: '55%' }}
                  className="counter-images"
                  loading="lazy"
                />
                <Typography mt={3} sx={{ color: '#fff' }}>
                  StartupTN Empanelled Vendor
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </div>

      <div className="about_area style-five">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6">
              <div
                className="single_about_thumb wow fadeInDown"
                data-wow-delay=".3"
              >
                <div className="single_about_thumb_inner">
                  {/* <img src="/images/about-main.png" alt="" /> */}
                  <img
                    src="/images/farmer1.webp"
                    alt=""
                    className="farmer-img img-fluid"
                    loading="lazy"
                    sizes=""
                  />
                  <div className="counter-area4"></div>
                </div>
                <div className="em-about-shape-thumb">
                  <div className="em-about-thmub-inner2">
                    <img src="/images/about-sp.webp" alt="" />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6">
              <div
                className="section_title style-two mb-30 mt-3 wow fadeInRight"
                data-wow-delay=".4"
              >
                <div className="section_sub_title">
                  <p className="sect-about">About</p>
                </div>
                <div className="section_main_title">
                  <h1 className="sect-about-head">
                    India&apos;s Leading IT Consulting & Software Development
                    Company
                  </h1>
                </div>
                <div className="section_content_text upper">
                  <p className="sect-about-para">
                    Amizhth is a global IT consulting and software development
                    firm dedicated to delivering secure, scalable, and
                    user-focused solutions. We specialize in IT consulting,
                    custom web app development, cybersecurity services, and
                    UI/UX design. Our mission is to empower businesses by
                    solving complex digital challenges with precision,
                    innovation, and design thinking. Whether you&apos;re a
                    growing startup or an established enterprise, we provide
                    tailored solutions that align with your goals.
                  </p>
                </div>
              </div>
              <div
                className="em-about-border-box1 pt-1 wow fadeInLeft"
                data-wow-delay=".5"
              >
                <div className="row em-border" style={{ marginBottom: '15px' }}>
                  <div className="col-md-6 col-lg-6">
                    <div className="em-about-icon-box">
                      <div className="em-about-icon">
                        {/* <img src="/images/icon-rs.png" alt="" /> */}
                        <img
                          src="/images/laptop.webp"
                          style={{ width: '32px' }}
                          alt=""
                          loading="lazy"
                          sizes=""
                        />
                      </div>
                      <div className="em-about-title">
                        <p className="em-about-cust">
                          <b>Custom Solutions</b>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-6">
                    <div
                      className="em-about-icon-box1 wow fadeInDown"
                      data-wow-delay=".6"
                    >
                      <div className="em-about-icon">
                        {/* <img src="/images/icon-cl.png" alt="" /> */}
                        <img
                          src="/images/dependable.webp"
                          style={{ width: '32px' }}
                          loading="lazy"
                          sizes=""
                          alt=""
                        />
                      </div>
                      <div className="em-about-title">
                        <p className="em-about-cust">
                          <b>Reliable Partnerships</b>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="row wow fadeInRight" data-wow-delay=".7">
                <div className="col-md-6 col-lg-12">
                  <div className="section_button2 mt-40">
                    <div className="abou-button1">
                      <a href="">
                        Contact Us
                        <i className="bi bi-arrow-right" aria-hidden="true"></i
                        ></a>
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
          <div className="em-about-shape">
            <div className="shape-thumb">
              <img src="/images/shape-ab.png" loading="lazy" alt="" />
            </div>
          </div>
        </div>
      </div>

      <div className="counter-area2">
        <div className="container">
          <div className="row counter-shap">
            <div className="col-lg-3 col-md-6">
              <div className="counter-titlee">
                <center>
                  <p className="counter">50+</p>
                </center>
                <center>
                  <p style={{ color: 'white' }}>
                    <span
                      style={{
                        display: 'block',
                        marginTop: '15px',
                        fontSize: '30px'
                      }}
                    >
                      Projects Completed
                    </span>
                  </p>
                </center>
                <div className="ems-border bounce-animate3"></div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="counter-titlee">
                <center>
                  <p className="counter">25+</p>
                </center>
                <center>
                  <p style={{ color: 'white' }}>
                    <span
                      style={{
                        display: 'block',
                        marginTop: '15px',
                        fontSize: '30px'
                      }}
                    >
                      Team size
                    </span>
                  </p>
                </center>
                <div className="em-border1 bounce-animate3"></div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="counter-titlee">
                <center>
                  <p className="counter">6+</p>
                </center>
                <center>
                  <p style={{ color: 'white' }}>
                    <span
                      style={{
                        display: 'block',
                        marginTop: '15px',
                        fontSize: '30px'
                      }}
                    >
                      Industries Served
                    </span>
                  </p>
                </center>
                <div className="ems-border bounce-animate3"></div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="counter-titlee">
                <center>
                  <p className="counter">3+</p>
                </center>
                <center>
                  <p style={{ color: 'white' }}>
                    <span
                      style={{
                        display: 'block',
                        marginTop: '15px',
                        fontSize: '30px'
                      }}
                    >
                      Countries Served
                    </span>
                  </p>
                </center>
                <div className="em-border2 bounce-animate3"></div>
              </div>
            </div>
            <div className="counter-shape-thumb">
              <img src="/images/box-2.webp" loading="lazy" alt="" />
            </div>
            <div className="counter-shape-thumb1 rotateme">
              <img src="/images/diamond2.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Techno;
